let activeToastElement = null;

/**
 * Create a custom toast using plain HTML/CSS
 */
function createToastElement(message, cssClass) {
  const toast = document.createElement('div');
  toast.className = `custom-toast ${cssClass}`;
  toast.textContent = message;
  
  // Style the toast
  Object.assign(toast.style, {
    position: 'fixed',
    bottom: '85px',
    left: '10px',
    right: '10px',
    padding: '12px 24px',
    borderRadius: '8px',
    zIndex: '99999',
    maxWidth: 'calc(100% - 20px)',
    textAlign: 'left',
    fontSize: '14px',
    fontWeight: '500',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    opacity: '0',
    transition: 'opacity 0.3s ease-in-out',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  });
  
  // Apply color based on class
  if (cssClass === 'error-toast') {
    toast.style.backgroundColor = '#e53935';
    toast.style.color = '#ffffff';
  } else if (cssClass === 'success-toast') {
    toast.style.backgroundColor = '#43a047';
    toast.style.color = '#ffffff';
  } else if (cssClass === 'warning-toast') {
    toast.style.backgroundColor = '#fb8c00';
    toast.style.color = '#ffffff';
  }
  
  return toast;
}

export function preloadToast() {
  console.log('✅ Using custom toast (no preload needed)');
}

export async function showPersistentToast(message, cssClass) {
  console.log('🍞 showPersistentToast called:', message, cssClass);
  try {
    // Remove existing toast if any
    if (activeToastElement) {
      console.log('🗑️ Removing existing toast');
      if (activeToastElement.parentNode) {
        activeToastElement.parentNode.removeChild(activeToastElement);
      }
      activeToastElement = null;
    }
    
    // Remove any orphaned toasts
    const existingToasts = document.querySelectorAll('.custom-toast');
    existingToasts.forEach(toast => {
      if (toast.parentNode) {
        toast.parentNode.removeChild(toast);
      }
    });
    
    // Create and show new toast
    console.log('🎨 Creating new toast element');
    const toast = createToastElement(message, cssClass);
    document.body.appendChild(toast);
    console.log('📌 Toast appended to body');
    
    // Trigger animation
    setTimeout(() => {
      if (toast.parentNode) {
        toast.style.opacity = '1';
        console.log('✨ Toast animation triggered');
      }
    }, 10);
    
    activeToastElement = toast;
    console.log('✅ Toast set as active');
    
  } catch (error) {
    console.error('❌ Failed to show persistent toast:', error);
  }
}

export async function showAutoToast(message, cssClass, duration = 1500) {
  try {
    // Remove existing persistent toast if any
    if (activeToastElement && activeToastElement.parentNode) {
      activeToastElement.style.opacity = '0';
      setTimeout(() => {
        if (activeToastElement && activeToastElement.parentNode) {
          activeToastElement.parentNode.removeChild(activeToastElement);
        }
        activeToastElement = null;
      }, 300);
    }
    
    // Create and show new toast
    const toast = createToastElement(message, cssClass);
    document.body.appendChild(toast);
    
    // Trigger animation
    setTimeout(() => {
      toast.style.opacity = '1';
    }, 10);
    
    // Auto dismiss after duration
    setTimeout(() => {
      toast.style.opacity = '0';
      setTimeout(() => {
        if (toast.parentNode) {
          toast.parentNode.removeChild(toast);
        }
      }, 300);
    }, duration);
    
  } catch (error) {
    console.error('❌ Failed to show auto toast:', error);
  }
}

export async function hidePersistentToast() {
  console.log('🗑️ hidePersistentToast called');
  
  try {
    if (activeToastElement) {
      console.log('🗑️ Toast exists, hiding');
      
      // Set opacity to 0 immediately
      activeToastElement.style.opacity = '0';
      console.log('🗑️ Set opacity to 0');
      
      // Store reference before clearing
      const toastToRemove = activeToastElement;
      activeToastElement = null;
      
      // Remove from DOM after animation
      setTimeout(() => {
        if (toastToRemove && toastToRemove.parentNode) {
          console.log('🗑️ Removing toast from DOM');
          toastToRemove.parentNode.removeChild(toastToRemove);
          console.log('✅ Toast removed successfully');
        }
      }, 300);
    } else {
      console.log('⚠️ No active toast to hide');
    }
  } catch (error) {
    console.error('❌ Failed to hide toast:', error);
  }
}